"use client";

import "./UiUxTestimonialSection.scss";
import user from "@/assets/images/testimonial/user.png";
import employee from "@/assets/images/testimonial/employee.png";
import client from "@/assets/images/testimonial/client.png";
import ClientTestimonialsSection from "@/components/ClientTestimonialsSection/ClientTestimonialsSection";

const UiUxTestimonialSection = () => {
  const uiuxtestimonialsData = [
    {
      name: "Dr. Sarah Jeon ",
      label: "Director of Digital Health · Orbix",
      description:
        "They redesigned our patient onboarding in 4 weeks. We were skeptical. Within 60 days, registration completion was up 58% and support tickets about 'confusing forms' dropped to near zero.",
      image: client,
    },
    {
      name: "Anika R",
      label: "VP Product, EdTech Platform ",
      description:
        'We\'d been told our app needed a "facelift." PixelMind figured out it actually needed a new information architecture. That insight alone saved us from a very expensive mistake. ',
      image: employee,
    },
    {
      name: "James T",
      label: "CTO, Healthcare SaaSDairy & Goat Farm Operator",
      description:
        "What impressed me most was that they showed up to every call with data from real users, not opinions. The usability recordings were eye-opening. We saw problems we didn't even know existed.",
      image: user,
    },
    {
      name: "Dinesh Babu",
      label: "Goat Farmer",
      description:
        "Expense tracking became very clear after using GOATAPP. We finally understand where our farm costs are going.",
      image: client,
    },
    {
      name: "PORTEA",
      label: "Modern Form Owner",
      description:
        "Partnering with GSUS Star Software Solutions for our SAP implementation has been a game-changer. We've achieved unparalleled business control, streamlined our resources, and unlocked innovative solutions.",
      image: employee,
    },
  ];
  return (
    <>
      {" "}
      <ClientTestimonialsSection
        title="Trusted by Clients"
        highlightTitle="Shop Owners"
        description="Trusted by growning meat brands and local butchers shops, the platform improves operational speed and keeps every department connected in real-time."
        testimonialsData={uiuxtestimonialsData}
      />
    </>
  );
};

export default UiUxTestimonialSection;
